import { render, staticRenderFns } from "./heng.vue?vue&type=template&id=71094412&scoped=true&"
import script from "./heng.vue?vue&type=script&lang=js&"
export * from "./heng.vue?vue&type=script&lang=js&"
import style0 from "./heng.vue?vue&type=style&index=0&id=71094412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71094412",
  null
  
)

export default component.exports